import { OrbisProvider, createGatsbyLinkAdapter } from '@mallpay/orbis';
import { Link as GatsbyLink } from 'gatsby';
import React, { ReactNode } from 'react';
import Helmet from 'react-helmet';

import '@skippay/core/stylesheets/index.sass';
import LocalizationProvider from '@skippay/core/components/LocalizationProvider';
import { LocaleProvider } from '@skippay/core/providers/LocaleProvider/LocaleProvider';

import { banksList, defaultMessages } from 'i18n/defaultConstants';
import { getAppLanguage } from 'i18n/languages';

interface Props {
	children: ReactNode;
}

const GatsbyLinkAdapter = createGatsbyLinkAdapter(GatsbyLink);

function ProvidersCommon({ children }: Props): JSX.Element {
	const appLanguage = getAppLanguage();

	return (
		<LocaleProvider appLanguage={appLanguage} getAppLanguage={getAppLanguage}>
			<OrbisProvider
				locale={appLanguage.locale}
				messages={defaultMessages[appLanguage.locale]}
				banksList={banksList[appLanguage.locale]}
				linkComponent={GatsbyLinkAdapter}
			>
				<LocalizationProvider ssrLanguageConfig={appLanguage}>
					<Helmet data-react-helmet="true">
						<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
					</Helmet>
					{children}
				</LocalizationProvider>
			</OrbisProvider>
		</LocaleProvider>
	);
}

export default ProvidersCommon;
